import JottaTerms from '@jotta/config/JottaTerms'
import { getDetectedLocale } from '@jotta/i18n'
import { cn } from '@jotta/utils/css'

export function JottaTermsAndConditions({ className }: { className?: string }) {
  const locale = getDetectedLocale()
  const termsHtml = locale in JottaTerms ? JottaTerms[locale] : JottaTerms.en
  return (
    <div
      className={cn(
        'prose p-8 text-2xl [&_a]:!text-signup-link [&_a]:!underline [&_h1]:font-bold [&_h3]:pb-2 [&_h3]:font-bold [&_p]:pb-2',
        className,
      )}
      dangerouslySetInnerHTML={{
        __html: termsHtml,
      }}
    />
  )
}
